//NOTE: For error messages specific to IS2.

const ErrorMessages = {
  ErrDateCompareInvalid: "Invalid dates to compare",
  ErrDateInvalid: "Date is invalid",
  ErrDateNotAfter: "Date must be after {afterDate}",
  ErrDateNotBefore: "Date must be before {beforeDate}",
  ErrDateNotTodayOrFuture: "Date must be today or a future date",
  ErrDecimalPoints: "No more than {decimalPoints} decimal points allowed",
  ErrUrlInvalid: "Must be a valid URL",
  ErrJsonInvalid: "Must be valid JSON",
  ErrSettingsInvalid:
    "Settings are invalid. Allowed settings are: {allowedSettings}. At least one setting must be provided.",
  ErrColorInvalid: "Must be a valid hex color code (e.g., #FFFFFF)",
};

export default ErrorMessages;
